import { Navigate, useRoutes } from 'react-router-dom';
import Cookies from 'universal-cookie';

import UserPage from './pages/users/UserPage';
import ContactPage from './pages/contact/ContactPage';

import LoginPage from './pages/login/LoginPage';
import Layout from './layouts/Layout';
import UpdateUser from './pages/users/UpdateUser';
import ContactDetails from './pages/contact/ContactDetails';
import AddNewUser from './pages/users/AddNewUser';
import ChangePassword from './pages/ChangePassword';
import Payments from './pages/payment/Payments';
import AddNewPayment from './pages/payment/AddNewPayment';
import UpdateProfile from './pages/users/UpdateProfile';
import { UpdateUserProfile } from './pages/users/UpdateUserProfile';
import CoursePage from './pages/courses/CoursePage';
import AddCourse from './pages/courses/AddCourse';
import ReturnHandler from './pages/impersonation/ReturnHandler';
// ----------------------------------------------------------------------



export default function Router() {
  const cookies = new Cookies();
  const token = cookies.get('admin_token');

  const routes = useRoutes([
    {
      path: '/',
      element: token ? <Layout /> : <Navigate to="/login" />,
      children: [
        { element: <Navigate to="/user" />, index: true },
        {
          path: '/user',
          element: <UserPage />,
        },
        {
          path: '/user/new',
          element: <AddNewUser />,
        },
        {
          path: '/user/:id',
          element: <UpdateUser />,
        },
        {
          path: '/user/profile/:id',
          element: <UpdateProfile />,
        },
        {
          path: '/user/update/:id',
          element: <UpdateUserProfile />,
        },
        {
          path: '/changePassword',
          element: <ChangePassword />,
        },
        {
          path: '/payment',
          element: <Payments />,
        },
        {
          path: '/payment/new',
          element: <AddNewPayment />,
        },
        {
          path: '/contact',
          element: <ContactPage />,
        },
        {
          path: '/contact/:id',
          element: <ContactDetails />,
        },
        {
          path: '/course',
          element: <CoursePage />,
        },
        {
          path: '/new/course',
          element: <AddCourse />,
        },
        {
          path: '/new/course/:id',
          element: <AddCourse />,
        },
      ],
    },
    {
      path: '/login',
      element: token ? <Navigate to="/user" /> : <LoginPage />,
    },
    {
      // Impersonation-return landing. Reachable without an admin cookie —
      // the JWT in the query string IS the auth. Do NOT wrap in the
      // token-guarded Layout (otherwise the guard would redirect to /login
      // before we get a chance to restore the session).
      path: '/impersonate/return',
      element: <ReturnHandler />,
    },,
    {
      element: <Layout />,
      children: [
        { element: <Navigate to="/user" />, index: true },
        { path: '*', element: <Navigate to="/" /> },
      ],
    },
    {
      path: '*',
      element: <Navigate to="/" replace />,
    },
  ]);

  return routes;
}
